<template>
    <div class="FormChangeStarZen">
        <v-row dense>
            <v-col cols="12" md="12" sm="12">
                <div class="custom-state">
                    <v-select :label="'*'+$t('reconciliation.label.state.title')" :placeholder="$t('reconciliation.label.state.text')" 
                        required :items="starZenStatus" item-text="label" item-value="value"
                        :rules="typeChangeStateRules" v-model="formData.approved" color="secondary"></v-select>
                </div>

                <br />
                <v-textarea :label="'*'+$t('label.observation.title')" :placeholder="$t('label.observation.text')" :counter="200" :maxlength="200"
                    required :rules="messageRules" v-model="formData.reasonMessage" outlined color="secondary">
                </v-textarea>
            </v-col>
            <v-btn large block rounded class="mb-4 custom-btn" color="primary" style="border-radius: 50px;"
                :disabled="!formData.approved || !formData.reasonMessage" @click="submitForm()">
                {{ $t('button.save') }}
            </v-btn>
        </v-row>
    </div>
</template>
<script>

import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
    STARASSIGNMENT_M,
    GET_STAR_ZEN_STATUS,
    ACTION_STAR_ZEN_STATUS,
    ACTION_POST_STAR_ZEN_STATUS
} from "@/views/star_assignment/store/types/types.js";
       
export default {
    name: "FormChangeStarZen",
    props: {
        dialog: {
            type: Boolean,
        },
        starZenForm: {
            required: false,
            default: null,
        },
    },

    data() {
        return {
            formData: {
                approved: null,
                reasonMessage: null
            },
            typeChangeStateRules: [
                v => !!v || this.$t('reconciliation.label.state.required')
            ],
            messageRules: [
                v => !!v || this.$t('label.observation.required')
            ],
        };
    },

    async mounted() {
        await this.getActionStarZenStatus();
    },
    methods: {
        ...mapActions({
            getActionStarZenStatus: `${STARASSIGNMENT_M}${ACTION_STAR_ZEN_STATUS}`,
            postActionStarZenStatus: `${STARASSIGNMENT_M}${ACTION_POST_STAR_ZEN_STATUS}`
        }),

        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }
            
                    if(this.formData){
                        let data = {
                            "approved": this.formData.approved == 1 ? true : false,
                            "reasonMessage": this.formData.reasonMessage,
                            "requestId": this.starZenForm.requestId,
                        }
                     
                        const update = await this.postActionStarZenStatus(data);

                        if (!update) {
                            return  Swal.fire({
                                icon: 'error',
                                title: i18n.t('label.invalid.title'),
                                text: i18n.t('label.invalid.text')
                            });
                        }

                    }else{
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('starAssignment.label.changeStatus')
                        });
                    }

                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error(i18n.t('label.failService'), error);
            }
        },

        validateForm() {
            const errors = {};
            if (!this.formData.approved) {
                errors.approved = this.$t('reconciliation.label.state.title');
            }

            if (!this.formData.reasonMessage || this.formData.reasonMessage.trim().length === 0) {
                errors.text = this.$t('label.observation.title');
            }

            return errors;
        },
    },

    computed: {
        ...mapGetters({
            starZenStatus: [`${STARASSIGNMENT_M}${GET_STAR_ZEN_STATUS}`],
        }),
    },
};
</script>
<style lang="css" scoped>
body {
    font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: "Amsi Pro", sans-serif;
}

img {
    width: 40vh;
}

.password-match-rule-error {
    color: red;
    font-size: 12px;
}

.custom-btn {
    border-radius: 50px;
    padding: 12px;
}

.custom-text {
    font-size: 16px;
    color: #000000;
    text-align: center;
    margin: 5px;
}

.nombre {
    font-size: 14px;
    color: #414141;
}

.nombre-claro {
    color: rgb(96, 96, 96);
}

.custom-state {
    color: #6e17a5;
    text-align: start;
    display: flex;
    padding-right: 100px;
}

.custom-archive {
    color: #6e17a5;
    text-align: start;
}

@media screen and (max-width: 900px) {
    .row {
        padding-top: 0vh;
    }
}
</style>